import { MdMenu } from "react-icons/md";

import { useAuth } from "../../../hooks/auth";
import { useLocation } from "react-router-dom";
import { useTranslateRouteName } from "../../../hooks/useTranslateRouteName";
import { HeaderDropdown } from "./components/Dropdown";

import * as S from "./styles";
import { FaCaretDown } from "react-icons/fa";
import { useResponsive } from "../../../hooks/useResponsive";
import { useTranslation } from "react-i18next";

export default function Header() {
  const { changeIsSideBarMenuOpen } = useResponsive();
  const { user } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();
  const { translateRouteName } = useTranslateRouteName();

  return (
    <>
      <S.HeaderContainer>
        <S.Title>{translateRouteName(location.pathname)}</S.Title>
        <S.UserContainer>
          <S.GreetingsText>
            {t("headerGreetings")}, <S.UserName>{user.user.name}!</S.UserName>
          </S.GreetingsText>

          <HeaderDropdown>
            <S.HeaderDropdownButton>
              <FaCaretDown />
            </S.HeaderDropdownButton>
          </HeaderDropdown>
        </S.UserContainer>
      </S.HeaderContainer>

      <S.MobileHeaderContainer>
        <S.HamburguerButton onClick={changeIsSideBarMenuOpen}>
          <MdMenu />
        </S.HamburguerButton>

        <S.UserContainer>
          <S.GreetingsText>
            {t("headerGreetings")}, <S.UserName>{user.user.name}</S.UserName>
          </S.GreetingsText>

          <HeaderDropdown>
            <S.HeaderDropdownButton>
              <FaCaretDown />
            </S.HeaderDropdownButton>
          </HeaderDropdown>
        </S.UserContainer>
      </S.MobileHeaderContainer>
    </>
  );
}
